module.exports = __webpack_public_path__ + "img/1559678112.a59e1edc.jpg";